import { render, staticRenderFns } from "./bdStuTable.vue?vue&type=template&id=1b7f1c6d&scoped=true"
import script from "./bdStuTable.vue?vue&type=script&lang=js"
export * from "./bdStuTable.vue?vue&type=script&lang=js"
import style0 from "./bdStuTable.vue?vue&type=style&index=0&id=1b7f1c6d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f1c6d",
  null
  
)

export default component.exports